module.exports = __webpack_public_path__ + "img/specialite.5d022366.png";